import { navigate } from 'gatsby';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { ProcessStepper } from '@components/ProcessStepper/index';
import RecordCard from '@components/RecordCard';

import * as ROUTES from '@constants/routes';

import type { FamilyHistoryRecord } from '@models/family-history';

const messages = defineMessages({
  age: {
    id: 'historyList.age',
    defaultMessage: 'age {age}',
  },
});

function HistoryList({ data = [] }: { data: FamilyHistoryRecord[] }) {
  const { formatMessage } = useIntl();
  if (data.length === 0) return null;

  return (
    <ProcessStepper
      allBlack
      stepNames={data
        .sort(({ conditions: conditionsA }, { conditions: conditionsB }) => {
          const conditionA = conditionsA.at(0)?.name;
          const conditionB = conditionsB.at(0)?.name;
          if (!conditionA) {
            return 1;
          }
          if (!conditionB) {
            return -1;
          }
          return conditionA.localeCompare(conditionB);
        })
        .map((r) => (
          <RecordCard
            key={r.id}
            noteDisplay={Boolean(r.recordNotes.length)}
            onClick={() => {
              navigate(`${ROUTES.FAMILY_HISTORY}${r.id}`);
            }}
            recordSource={r.recordSource}
            status={r.curationStatus}
            text={r.conditions
              .map(
                ({ ageDiagnosed, name }) =>
                  `${name}${
                    ageDiagnosed
                      ? ` (${formatMessage(messages.age, {
                          age: ageDiagnosed,
                        })})`
                      : ''
                  }`
              )
              .join(', ')}
            topText={r.relationship?.name}
            viewed={r.viewedStatus}
          />
        ))}
    />
  );
}

export default HistoryList;
